module.exports = __webpack_public_path__ + "static/media/achievement-kid-currency.d6ea2b64.svg";